import get from 'lodash/get';
import {isMobile} from '@utils/ui';

/* Components */
import {ZipSplitTest} from '@components/Sku/ZipCodeEntry/ZipCodeEntry';

/* Types */
import {MergeSkuPrice, Sku} from 'types/sku.types';
import {Cart} from 'types/cart.types';
import {User} from 'types/user.types';

/*
 *
 * This intention is to append to the sku for additional key values
 */
type MergedSkuData = {
  cart: Cart;
  user: User;
  sku: Sku;
  showZipCodeTest: ZipSplitTest;
  prices: MergeSkuPrice;
  showUpsell: boolean;
};

export const mergeSkuData = ({prices, showUpsell, cart, user, sku, showZipCodeTest}: MergedSkuData) => {
  const showMemberPrice = !!(cart.plan || (user && user.account?.hasSubscription)) && prices.memberPrice;
  const {ratingAttributes} = sku;
  const mobile = isMobile();
  const ctaMember = showMemberPrice && showUpsell ? 'Join & Book Now' : 'Book Now';
  const ctaOverride = showZipCodeTest ? 'Get A Price' : ctaMember;

  return {
    bannerText: `HelloTech Home members save up to ${prices.priceDifference} on this service.`,
    upsellSelected: !!cart.plan,
    ctaText: ctaOverride,
    showStickyBookNow: isMobile,
    reviewsScrollOffset: mobile ? 100 : 130,
    image: mobile ? sku.heroMobileImageUrl : sku.heroImageUrl,
    rating: ratingAttributes && ratingAttributes.rating > 0 && ratingAttributes,
    selectedPlanId: get(cart, 'plan.id', null),
    // FIX ME FIXME TODO: should not be hardcoded
    annualSavings: 100,
    subscriptionPrices: {cheapestPrice: 6900, cheapestPriceFormatted: '$69'},
    showUpsell,
    showMemberPrice,
    prices,
    showZipCodeTest,
  };
};
